<template>
  <ScreenAdapter>
    <div class="main">
      <div class="header">
        <div class="title">智慧养老可视化系统</div>
      </div>
      <div class="content">
        <div class="left-con">
          <!-- 楼栋概况 -->
          <div class="left-top">
            <div class="item-title">楼栋概况</div>
            <div class="data-con">
              <div class="data-item" v-for="item in data_1" :key="item">
                <div class="data-num">{{ item.value }}</div>
                <div class="data-title">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ScreenAdapter>
</template>

<script>
import ScreenAdapter from "@/components/ScreenAdapter"; // 自适应组件

export default {
  components: {
    ScreenAdapter,
  },
  data() {
    return {
      data_1: [
        {
          title: "房间数（间）",
          value: 1200,
        },
        {
          title: "总床位（床）",
          value: 2400,
        },
        {
          title: "入住人数",
          value: 1500,
        },
        {
          title: "入住率（%）",
          value: 62.5,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: calc(100% - 64px);
  height: 100%;
  margin: 0 auto;
  position: relative;
  // background: url("../assets/home/index.png") no-repeat center;
  background: url("../assets/home/bg.jpg") no-repeat center;
  background-size: contain;
  background-position: center 50px;
  overflow: hidden;
  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1200px;
    height: 112px;
    background: url("../assets/home/title_bg.png") no-repeat center;
    margin: 0 auto;
    .title {
      font-size: 44px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      color: #ffffff;
    }
  }
  .content {
    width: 100%;
    height: auto;
    min-height: 932px;
    display: flex;
  }
  .item-title {
    box-sizing: border-box;
    width: 100%;
    padding: 16px 12px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 28px;
  }
  .left-con {
    width: 400px;
    height: 100%;
    .left-top {
      width: 100%;
      height: 302px;
      background: linear-gradient(
        90deg,
        rgba(54, 196, 255, 0.16) 0%,
        rgba(54, 196, 255, 0) 100%
      );
      overflow: hidden;
      .data-con {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        .data-item {
          width: 50%;
          height: 100px;
          text-align: center;
          color: #ffffff;
          .data-num {
            font-size: 28px;
            font-weight: bold;
          }
          .data-title {
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>
